import React from 'react'
import ReactDOM from 'react-dom'
import {BrowserRouter as Router} from 'react-router-dom'
import './index.css'
import App from './App'
import registerServiceWorker from './registerServiceWorker'
import WebFont from 'webfontloader'
import './i18n'
import { Provider } from 'react-redux'
import store from './redux/store'

WebFont.load({
    google: {
        families: ['Roboto:300,400,700', 'Roboto Slab'],
    },
})


ReactDOM.render(
    <React.StrictMode>
        <Provider store={store()}>
            <Router>
                <App/>
            </Router>
        </Provider>
        ,
    </React.StrictMode>
    ,
    document.getElementById('root'),
)
registerServiceWorker()



// WEBPACK FOOTER //
// ./src/index.js